import { useRoutes } from "react-router-dom";
import FullScreenLayout from "../layouts/FullScreenLayout";
import Map from "../pages/Map";
import MenuLayout from "../layouts/MenuLayout";
import BangGiaDat from "../pages/BangGiaDat";
import KhungGiaDat from "../pages/KhungGiaDat";
import TimRanhGioiTuyenDuong from "../pages/TimRanhGioiTuyenDuong";
import KhuVucGiaDat from "../pages/KhuVucGiaDat";
import HeSoDieuChinh from "../pages/HeSoDieuChinh";
import TraCuuLichSuGiaDat from "../pages/TraCuuLichSuGiaDat";
import NhapLichSuGiaDat from "../pages/NhapLichSuGiaDat";
import DangNhap from '../pages/DangNhap';

export default function Router() {
  return useRoutes([
    {
      path: `/`,
      element: <FullScreenLayout />,
      children: [{ element: <DangNhap />, index: true }],
    },
    {
      path: `/map`,
      element: <FullScreenLayout />,
      children: [{ element: <Map />, index: true }],
    },
    {
      path: `/bang-gia-dat`,
      element: <MenuLayout />,
      children: [{ element: <BangGiaDat />, index: true }],
    },
    {
      path: `/khung-gia-dat`,
      element: <MenuLayout />,
      children: [{ element: <KhungGiaDat />, index: true }],
    },
    {
      path: `/lich-su-gia-dat`,
      element: <MenuLayout />,
      children: [{ element: <TraCuuLichSuGiaDat />, index: true }],
    },
    {
      path: `/tim-tuyen-duong`,
      element: <MenuLayout />,
      children: [
        {
          element: <TimRanhGioiTuyenDuong type="tim tuyến đường" isTimTuyenDuong />,
          index: true,
        },
      ],
    },
    {
      path: `/ranh-gioi-tuyen-duong`,
      element: <MenuLayout />,
      children: [
        {
          element: <TimRanhGioiTuyenDuong type="ranh giới tuyến đường" />,
          index: true,
        },
      ],
    },
    {
      path: "/khu-vuc-gia-dat",
      element: <MenuLayout />,
      children: [{ element: <KhuVucGiaDat />, index: true }],
    },
    {
      path: "/he-so-dieu-chinh",
      element: <MenuLayout />,
      children: [{ element: <HeSoDieuChinh />, index: true }],
    },    
    {
      path: "/chuyen-khung-gia-dat-vao-lich-su",
      element: <MenuLayout />,
      children: [{ element: <NhapLichSuGiaDat  />, index: true }],
    },
    {
      path: "/chuyen-bang-gia-dat-vao-lich-su",
      element: <MenuLayout />,
      children: [{ element: <NhapLichSuGiaDat  />, index: true }],
    },
    {
      path: "/chuyen-he-so-dieu-chinh-vao-lich-su",
      element: <MenuLayout />,
      children: [{ element: <NhapLichSuGiaDat  />, index: true }],
    },
    
  ]);
}
